import { Identifier } from "../../core";
export class OrderCouponCode extends Identifier {
    constructor(code) {
        super("OrderCouponCode", code);
    }
}
